export function calcFutureValueSimpleInflation(
  principal: number,
  annualRateOfReturn: number,
  yearsOfGrowth: number,
): number {
  const growthPerYear = principal * annualRateOfReturn;
  const totalInterest = growthPerYear * yearsOfGrowth;

  return principal + totalInterest;
}
